import { render, staticRenderFns } from "./VendorBidStatusTable.vue?vue&type=template&id=84329820&scoped=true&"
import script from "./VendorBidStatusTable.vue?vue&type=script&lang=js&"
export * from "./VendorBidStatusTable.vue?vue&type=script&lang=js&"
import style0 from "./VendorBidStatusTable.vue?vue&type=style&index=0&id=84329820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84329820",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84329820')) {
      api.createRecord('84329820', component.options)
    } else {
      api.reload('84329820', component.options)
    }
    module.hot.accept("./VendorBidStatusTable.vue?vue&type=template&id=84329820&scoped=true&", function () {
      api.rerender('84329820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/view/VendorBidStatusTable.vue"
export default component.exports